var map = {
	"./controller-generic.png": "b044",
	"./controller-none.png": "c558",
	"./controller-ps3.png": "9806",
	"./controller-ps4.png": "60c5",
	"./controller-xbox360.png": "dc92",
	"./controller-xboxone.png": "3b0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fd42";